/**
 * 现场服务二级导航tabbar
 */
export enum SITE_SERVICE_TABS {
  LEASE = 'lease',
  INVOICE = 'invoice',
  DRAWBACK = 'drawback',
  GIFTWRAP = 'giftwrap',
  EXPRESS = 'express',
  THIRD = 'third',
  SUGGEST = 'suggest',
  L_AND_F = 'l-and-f',
  LUGGAGE = 'luggage',
  OTHER = 'other',
  RECORD = 'record',
}

/**
 * 匹配客户
 */
export interface MatchInfo {
  /**
   * 手机号
   */
  phone: string;
  /**
   * 会员号
   */
  user_code: string;
}

/**
 * 匹配客户表单默认值
 */
export const defaultInfo: MatchInfo = {
  phone: '',
  user_code: '',
};